module.exports = __webpack_public_path__ + "img/10.5bfd8b6c.png";